/* istanbul ignore file */
export function printIndexContext (children, node) {
    for (var i = 0; i < children.length; i++) {
        const child = children[i]
        const li = document.createElement('li')
        const ul = document.createElement('ul')

        ul.style = 'padding-left: 20px'
        let linkStyle = 'font-size: 1em; font-weight: 300;'
        if (child.level === 1) {
            linkStyle = 'font-size: 1.2em; font-weight: 500;'
        }
        if (child.level === 2) {
            linkStyle = 'font-size: 1.2em; font-weight: 300;'
        }
        const a = document.createElement('a')
        a.style = linkStyle
        /* eslint-disable-next-line xss/no-mixed-html */
        a.innerHTML = child.title
        a.href = '#' + child.id
        li.appendChild(a)
        if (child.children.length > 0) {
            li.appendChild(ul)
            printIndexContext(child.children, ul)
        }
        node.appendChild(li)
    }
}

/* istanbul ignore next */
function getParent (level, needle) {
    if (level - 1 < needle.level) {
        return getParent(level, needle.parent)
    }
    if (level - 1 > needle.level) {
        return (level, needle.children[needle.children.length - 1])
    }
    return needle
}

export function getIndex (nodes) {
    var indexContent = {
        children: [],
        level: 0,
    }
    var needle = indexContent
    for (var i = 0; i < nodes.length; i++) {
        const node = nodes[i]
        const level = parseInt(node.nodeName.slice(1))
        const parent = getParent(level, needle)
        const id = 'h' + level + '_' + i
        const current = {
            parent: parent,
            title: node.innerText,
            children: [],
            level: level,
            id: id,
        }
        node.setAttribute('id', id)
        parent.children.push(current)
        if (needle !== parent) {
            needle = parent
        }
    }
    return indexContent
}

/* istanbul ignore next */
export default function formatIndexFromHtml (objectIdOrigin, objectIdDestination) {
    const originElement = document.getElementById(objectIdOrigin)
    const destinationElement = document.getElementById(objectIdDestination)
    if (objectIdDestination && originElement) {
        printIndexContext(
            getIndex(originElement.querySelectorAll('h1,h2,h3,h4,h5,h6')).children,
            destinationElement
        )
    }
}
